import React from 'react'
import PropTypes from 'prop-types'
import queryString from 'query-string'
import styled, { css } from 'styled-components'
import { Button, TextSubHeading, IconFilter } from 'blocket-ui'
import { nonDefaultParameters } from 'utils/parameters'
import { mediaQueries } from '@blazar-plugins/device'

export const sharedButtonStyles = css`
  button {
    height: 32px;
    margin: 4px 0;
    border-radius: 4px;
    @media ${mediaQueries.large} {
      margin: 0;
    }
  }
`

export const sharedButtonTextStyles = css`
  padding-left: 10px;
  font-size: 15px;
`

const StyledButton = styled(Button)`
  ${sharedButtonStyles}
  grid-row: 1;
  grid-column: 2/3;

  @media ${mediaQueries.large} {
    grid-column: 1/2;
  }
`

const StyledButtonText = styled(TextSubHeading)`
  ${sharedButtonTextStyles}
`

function FilterButton({ classifiedActions, parameters, location }) {
  const numberOfFilters = nonDefaultParameters(parameters, queryString.parse(location.search))

  return (
    <StyledButton
      onClick={() => {
        classifiedActions.clickedShowFilter()
      }}
      data-cy="filter-toggle"
    >
      <IconFilter width={21} height={21} color="#363434" />
      <StyledButtonText>
        Filtrera
        {numberOfFilters > 0 && ` (${numberOfFilters})`}
      </StyledButtonText>
    </StyledButton>
  )
}

FilterButton.propTypes = {
  classifiedActions: PropTypes.object.isRequired,
  parameters: PropTypes.array.isRequired,
  location: PropTypes.object.isRequired,
}

export default FilterButton
